import GenericSlider from "../components/GenericSlider";
import { api } from "../API";
import Vue from "vue";
import SiteSelect from "../vue/SiteSelect.vue";
import CreateOrderModal from "../vue/Modals/CreateOrderModal.vue";
import { createModal } from "../components/modal";
import { $t } from "../i18n";

window.eventBus = new Vue();

window.removeA = function (arr) {
  let what,
    a = arguments,
    L = a.length,
    ax;
  while (L > 1 && arr.length) {
    what = a[--L];
    while ((ax = arr.indexOf(what)) !== -1) {
      arr.splice(ax, 1);
    }
  }
  return arr;
};

window.setCookie = function (name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
};

window.getCookie = function (name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

window.eraseCookie = function (name) {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
};

export default {
  _siteSelect() {
    const state = {
      expanded: false,
      sites: {
        loaded: false,
        loading: false,
        data: [],
      },
    };

    window.vueState = state;

    Vue.prototype.$icons = {
      "search-site-icon": require("../../images/icons/search-site-icon.svg"),
      "search-site-calendar": require("../../images/icons/search-site-calendar.png"),
      "search-site-ski": require("../../images/icons/search-site-ski.svg"),
    };

    // new Vue({
    //   data: state,
    //   el: "#site-select-container .site-select-placeholder",
    //   template: `<SiteSelect :modal="true" :desktop="true" @expand="expanded = true" :sites="sites" @load="onLoad" />`,
    //   methods: {
    //     onLoad(sites) {
    //       this.sites = sites;
    //     },
    //   },
    //   components: { SiteSelect },
    // });

    if (document.querySelector("#site-select-container-mobile")) {
      new Vue({
        data: state,
        el: "#site-select-container-mobile .site-select-placeholder",
        template: `<SiteSelect @expand="expanded = true" :sites="sites" />`,
        methods: {
          onLoad(sites) {
            console.log("loaded");
            this.sites = sites;
          },
        },
        components: { SiteSelect },
      });
    }

    new Vue({
      data: state,
      el: ".site-drawer-search .site-select-placeholder",
      template: `<SiteSelect @expand="expanded = true" :from-menu="true" :sites="sites" @load="onLoad" />`,
      methods: {
        onLoad(sites) {
          this.sites = sites;
        },
      },
      components: { SiteSelect },
    });

    new Vue({
      data: state,
      el: "#site-select-modal .site-select-placeholder",
      template: `<SiteSelect :modal="true" :expanded="expanded" :sites="sites" @collapse="expanded = false" />`,
      components: { SiteSelect },
    });

    new Vue({
      data: state,
      el: "#site-topselect-search .site-select-placeholder",
      template: `<SiteSelect :modal="true" :fixedmodal="true" :desktop="true" @expand="expanded = true" :sites="sites" @load="onLoad" />`,
      methods: {
        onLoad(sites) {
          this.sites = sites;
        },
      },
      components: { SiteSelect },
    });

    if (
      document.querySelector(
        "#searching-page-filtering .site-select-placeholder"
      )
    ) {
      new Vue({
        data: () => ({ ...state }),
        el: "#searching-page-filtering .site-select-placeholder",
        template: `<SiteSelect :modal="true" :desktop="true" :expanded="expanded" @expand="expanded = true" @collapse="expanded = false" :sites="sites" @load="onLoad" rootInputText="${$t(
          $t("חיפוש")
        )}" inSearchPage/>`,
        methods: {
          onLoad(sites) {
            this.sites = sites;
          },
        },
        components: { SiteSelect },
      });
    }
  },

  _createOrderModal() {
    const state = {
      packageData: null,
    };
    window.createOrderModalState = state;

    new Vue({
      data: state,
      el: "#create-order-modal",
      template: `<CreateOrderModal :packageData="packageData" />`,
      components: { CreateOrderModal },
    });
  },

  init() {
    this._siteLogin();
    this._welcomeModal();
    this._mobileHeaderAnimation();
    this._mobileMenus();
    this._mobileDrawer();
    this._siteTabs();
    this._genericSliders();
    this._hotelExtraContents();
    this._floatShare();
    this._frameVideo();
    this._agentSendOffer();
    this._orderPackageBtn();
    this._shareButtonPackage();
    this._fbGoogleEvents();
    this._siteSelect();
    this._createOrderModal();
    this._continueOrderModal();
    this._stickyContactForm();
    // this._siteMenuSearch();

    document.addEventListener("wpcf7submit", (event) => {
      $(event.target)
        .find(".wpcf7-submit")
        .prop("disabled", false)
        .removeClass("disabled-button");
    });

    $("form.wpcf7-form").on("submit", function () {
      let form = $(this);
      form
        .find("input[type=submit]")
        .prop("disabled", true)
        .addClass("disabled-button");
    });

    window.onload = function () {
      const $stickyMobileContact = $(".sticky-bottom-mobile");

      $stickyMobileContact.addClass("show");

      if ($(".login-modal").hasClass("initboot")) {
        $(".login-modal").modal().show();
      }

      jQuery(".swiper-slide.lazy").each((idx, el) => {
        const bg = jQuery(el).data("bg");
        jQuery(el).css("background-image", bg);
        jQuery(el).removeClass("lazy");
      });

      jQuery(".background.lazy").each((idx, el) => {
        const bg = jQuery(el).data("bg");
        jQuery(el).css("background-image", bg);
        jQuery(el).removeClass("lazy");
      });
    };
    $(function () {
      $(".site-search.site-search-global form input").on("focus", function () {
        if (!$(".site-search.site-search-global").hasClass("active")) {
          $(".site-search.site-search-global").addClass("active");
        }
      });
      $(".site-search.site-search-global form input").on("blur", function () {
        if ($(".site-search.site-search-global").hasClass("active")) {
          $(".site-search.site-search-global").removeClass("active");
        }
      });
      $(window).scroll(function () {
        const $tabSliderTabs = $(".app-page-header.app-page-header-revslider");
        if ($tabSliderTabs.length && $(window).width() > 1024) {
          const $windowTop = $(window).scrollTop();
          const $tabSliderBottom =
            $tabSliderTabs.offset().top +
            $tabSliderTabs.outerHeight(true) -
            300;
          if ($windowTop > $tabSliderBottom) {
            $("#site-topselect-search").addClass("active");
          } else {
            $("#site-topselect-search").removeClass("active");
          }
        }
      });
      $(window).scroll(function () {
        if ($(window).width() < 1024) {
          const $windowTop = $(window).scrollTop();

          if ($windowTop > 400) {
            $("header.site-header-mobile").addClass("scrolled");
            $("header.site-header-mobile .site-logo img").addClass("scrolled");
          } else {
            $("header.site-header-mobile").removeClass("scrolled");
            $("header.site-header-mobile .site-logo img").removeClass(
              "scrolled"
            );
          }
        }
      });
    });
    $(window).scroll(function () {
      if ($(window).width() < 1024) {
        // console.log($(window).scrollTop());
      }
      // const $windowTop = $(window).scrollTop();
      //
      // const $stickyMobileContact = $(".sticky-bottom-mobile");
      //
      // if ($windowTop > 150 && !$stickyMobileContact.hasClass("show")) {
      //   $stickyMobileContact.addClass("show");
      // } else if ($windowTop < 150) {
      //   if ($stickyMobileContact.hasClass("show")) {
      //     $stickyMobileContact.removeClass("show");
      //   }
      // }
    });

    var wpcf7Elm = document.querySelector(".contact-page-form .wpcf7");
    var contactBottom = document.querySelector(".contact-bottom");
    var stickyForm = document.querySelector("#sticky-contact-form");
    var orderPkgModal = document.querySelector(".order-package-modal .wpcf7");
    // var hotelForm = document.querySelector(
    //   "body.tax-hotel .float-contact-form"
    // );
    var footerNewsletter = document.querySelector("footer .newsletter .wpcf7");

    const mapContactFormLead = function ($el, $source, $sendToQuiz = true) {
      window.location.href = window.siteData.thanks;
      // after return it's the old lead creation
      return;

      let fullName = $el.find("input[name=full-name]").val();
      let i = fullName.indexOf(" ");
      let firstName = "",
        lastName = "";
      if (i === -1) {
        firstName = fullName;
      } else {
        firstName = fullName.slice(0, i);
        lastName = fullName.slice(i, fullName.length).trim();
      }

      let submitBtn = $el.find("button[type=submit]");

      let tel = $el.find("input[name=your-tel]").val();
      let email = $el.find("input[name=email]").val();

      let siteName = $el.find("input[type=text][name=pkg_site_name]").length
        ? $el.find("input[type=text][name=pkg_site_name]").val()
        : false;
      let pkgDate = $el.find("input[type=text][name=pkg_date]").length
        ? $el.find("input[type=text][name=pkg_date]").val()
        : false;
      let pkgHotel = $el.find("input[type=text][name=pkg_hotel]").length
        ? $el.find("input[type=text][name=pkg_hotel]").val()
        : false;

      const sendValues = {
        first_name: firstName,
        last_name: lastName,
        phone: tel,
        from: $source,
        url: window.location.href,
        to_quiz: $sendToQuiz,
      };

      if (siteName) {
        sendValues.pkg_site_name = siteName;
      }

      if (pkgDate) {
        sendValues.pkg_date = pkgDate;
      }

      if (pkgHotel) {
        sendValues.pkg_hotel = pkgHotel;
      }

      if (email && email.length) {
        sendValues.email = email;
      }

      // api.createSalesforceLead(sendValues).then(res => {
      //   if ($sendToQuiz) {
      //     window.location.href = res.redirect;
      //   }
      // });
    };

    if (footerNewsletter) {
      footerNewsletter.addEventListener(
        "wpcf7mailsent",
        function (event) {
          const $modal = $(".info-modal");
          $modal.find(".info-modal-title").html($t("הצטרף לניוזלטר שלנו"));
          $modal.find(".info-modal-content").html($t("בקשתך התקבלה בהצלחה!"));
          $modal.modal().show();
        },
        false
      );
    }

    if (wpcf7Elm) {
      wpcf7Elm.addEventListener(
        "wpcf7mailsent",
        function (event) {
          mapContactFormLead($(".contact-page-form"), $t("עמוד צור קשר באתר"));
        },
        false
      );
    }

    if (contactBottom) {
      contactBottom.addEventListener(
        "wpcf7mailsent",
        function (event) {
          mapContactFormLead($(".contact-bottom"), $t("טופס קבלת הצעה באתר"));
        },
        false
      );
    }

    if (stickyForm) {
      stickyForm.addEventListener(
        "wpcf7mailsent",
        function (event) {
          window.location.href = window.siteData.thanksMaxi;

          // mapContactFormLead(
          //   $("#sticky-contact-form"),
          //   $t("טופס קבלת הצעה באתר צד סטיקי")
          // );
        },
        false
      );
    }

    if (orderPkgModal) {
      orderPkgModal.addEventListener(
        "wpcf7mailsent",
        function (event) {
          mapContactFormLead(
            $(".order-package-modal .wpcf7"),
            $t("טופס קבל הצעה של חבילה")
          );
        },
        false
      );
    }

    // if (hotelForm) {
    //   hotelForm.addEventListener(
    //     "wpcf7mailsent",
    //     function(event) {
    //       mapContactFormLead(
    //         $("body.tax-hotel .float-contact-form"),
    //         $t("טופס קבלת הצעה בעמוד מלון")
    //       );
    //     },
    //     false
    //   );
    // }
  },

  _shareButtonPackage() {
    $("a.featured-package-thumb .share-button").on("click", function (e) {
      e.preventDefault();
    });

    $("a.hotel-thumbnail .share-button").on("click", function (e) {
      e.preventDefault();
    });

    $("a.swiper-slide .share-button").on("click", function (e) {
      e.preventDefault();
    });
  },

  _orderPackageBtn() {
    const orderBtnClick = function (el) {
      const hotel = el.data("hotel");
      const packageDate = el.data("package");
      const site = el.data("site");

      const orderFormModal = $(".order-package-modal");

      orderFormModal.find("input[type=text][name=pkg_site_name]").val(site);
      orderFormModal.find("input[type=text][name=pkg_date]").val(packageDate);
      orderFormModal.find("input[type=text][name=pkg_hotel]").val(hotel);

      orderFormModal.modal().show();
    };

    $(window).on("load", () => {
      if ($("body").hasClass("single-site")) {
        const data = window.location.hash.substr(1).split("/");
        const packageId = data[1];
        const hotelId = data[0];

        if (data && data[0]) {
          const target = $(`.hotel-links a.hotel-item[data-target=${hotelId}]`);

          if (target.length) {
            target.trigger("click");
          }
        }

        // if (data && data[1]) {
        //   const target = $(`.create-order-button[data-id=${packageId}]`);

        //   if (target.length) {
        //     target.trigger("click");
        //   }
        // }

        if (hotelId && packageId) {
          window.location.hash = `${hotelId}/${packageId}`;
        }
      }
      let localLink = localStorage.getItem("siteLink");
      if (localLink === window.location.href) {
        let data = window.location.hash.substr(1).split("/");
        let packageId = data[1];
        let hotelId = data[0];
        if (data && data[0]) {
          const target = $(`.hotel-links a.hotel-item[data-target=${data[0]}]`);
          if (target.length) {
            target.trigger("click");
          }
        }
      }
      //console.log(localLink);
    });

    $(document).on("click", ".order-package-button", function (e) {
      e.preventDefault();

      orderBtnClick($(this));
    });

    $(".order-package-button").on("click", function (e) {
      e.preventDefault();

      orderBtnClick($(this));
    });

    $(".create-order-button").on("click", function (e) {
      e.preventDefault();
      var hotelId = $(this).data("hotel-id");
      var packageId = $(this).data("id");

      let odyssey = $(this).data("odyssey");

      // window.location.hash.split("/")[0];
      // window.location.hash.split("/")[1];

      window.location.hash = `${hotelId}/${packageId}`;

      if (!odyssey.packageId) {
        orderBtnClick($(this));
        return;
      }

      let packageData = {
        ...odyssey,
        random: Math.random(), // Force Vue to update.
      };

      window.createOrderModalState.packageData = packageData;
    });

    $(document).on("click", ".create-order-button", function (e) {
      e.preventDefault();
      var hotelId = $(this).data("hotel-id");
      var packageId = $(this).data("id");

      let odyssey = $(this).data("odyssey");

      // window.location.hash.split("/")[0];
      // window.location.hash.split("/")[1];

      window.location.hash = `${hotelId}/${packageId}`;

      if (!odyssey.packageId) {
        orderBtnClick($(this));
        return;
      }

      let packageData = {
        ...odyssey,
        random: Math.random(), // Force Vue to update.
      };

      window.createOrderModalState.packageData = packageData;
    });
  },

  _agentSendOffer() {
    $(document).on("click", ".quote-success-overlay", function (e) {
      if ($(".quote-success-modal").hasClass("active")) {
        $(".quote-success-modal").removeClass("active");
      }
    });

    $(document).on("click", ".agent-offer-iframe", function (e) {
      if (
        $(e.target).is(".agent-offer-iframe") &&
        $(".agent-offer-iframe").hasClass("active")
      ) {
        const iframe = $(".agent-offer-iframe");
        iframe.find("iframe").attr("src", "");
        iframe.toggleClass("active");
      }
    });

    $(document).on("click", "a.trigger-agent-offer", function (e) {
      e.preventDefault();

      const href = $(this).attr("href");

      const iframe = $(".agent-offer-iframe");
      iframe.find("iframe").attr("src", href);
      iframe.toggleClass("active");
    });

    $(document).on("click", ".agent-offer-iframe .close", function (e) {
      e.preventDefault();
      const iframe = $(".agent-offer-iframe");
      iframe.toggleClass("active");
      iframe.find("iframe").attr("src", "");
    });
  },

  _frameVideo() {
    $(".frame-video").on("click", function () {
      $(this).addClass("active");
    });
  },

  _floatShare() {
    $(".share-button").on("click", function () {
      $(this).toggleClass("active");
    });

    $(".float-share-buttons").on("click", function () {
      $(this).toggleClass("active");
    });

    $("body").on("click", function (e) {
      if (
        !$(e.target).hasClass("float-share-buttons") &&
        $(".float-share-buttons").hasClass("active")
      ) {
        $(".float-share-buttons").removeClass("active");
      }
    });
  },

  _welcomeModal() {
    $(".welcome-back-modal .close-modal").click(function () {
      $(".welcome-back-modal").modal().hide();
    });
  },

  _siteLogin() {
    const $modal = $(".regular-login-modal");
    // console.log($modal);
    $(".logout-action").click(function (e) {
      e.preventDefault();

      api.customerLogout().finally(() => {
        window.location.reload();
      });
    });

    $(".login-action").click(function () {
      window.location.assign("/regular-login/");
    });

    $modal.modal().show();
    $modal.find(".modal-close").hide();

    let step = 1;
    $modal.find(".login-step-1").show();
    $modal.find(".login-step-2").hide();

    $modal.find(".resend-security-code-btn").click(function () {
      $(this).text($t("שולח...")).addClass("disabled");

      const idNumber = $modal.find("input[name=id-number]").val();

      const phoneNumber = $modal.find("input[name=phone-number]").val();

      const type = $modal.find("input[name=type]:checked").val();

      api
        .customerLogin(idNumber, phoneNumber, type)
        .then((resp) => {
          $(this).text($t("שלח שוב")).removeClass("disabled");
        })
        .catch((err) => {
          let message = $t("אופס, יש בעיה. נסה שנית מאוחר יותר.");
          if (err.responseJSON) {
            message = err.responseJSON.message;
          }
          $(this).find(".form-error").text(message).slideDown(150);
        });
    });

    $modal.find("form").submit(function (e) {
      e.preventDefault();

      const idNumber = $(this).find("input[name=id-number]").val();

      const phoneNumber = $(this).find("input[name=phone-number]").val();

      const type = $(this).find("input[name=type]:checked").val();

      const securityCode = $(this).find("input[name=security-code]").val();

      if (step == 2 && !securityCode) {
        return;
      }

      $(this).find(".form-error").slideUp(150);

      $(this)
        .find("button[type=submit]")
        .text($t("מתחבר..."))
        .prop("disabled", true);

      api
        .customerLogin(idNumber, phoneNumber, type, securityCode)
        .then((resp) => {
          if (resp.security_code_required) {
            step = 2;

            $modal.find(".login-step-1").hide();
            $modal.find(".login-step-2").show();

            if (type === "phone") {
              $modal
                .find(".login-step-2-text")
                .text("סימסנו לך קוד אבטחה למספר");
              $modal
                .find(".login-step-2-phone-number")
                .text($modal.find("input[name=phone-number]").val());
            } else {
              $modal
                .find(".login-step-2-text")
                .text("שלחנו לך את קוד האבטחה לאימייל");
            }

            $(this)
              .find("button[type=submit]")
              .text($t("התחבר"))
              .prop("disabled", false);

            return;
          }

          window.location = resp.to_personal_area
            ? "/אישי"
            : resp.show_discount
            ? "/?discount=1"
            : "/";

          $(this)
            .find("button[type=submit]")
            .text($t("אתה מועבר..."))
            .prop("disabled", true);
        })
        .catch((err) => {
          let message = $t("אופס, יש בעיה. נסה שנית מאוחר יותר.");
          if (err.responseJSON) {
            message = err.responseJSON.message;
          }

          if (
            err.responseJSON &&
            err.responseJSON.data &&
            err.responseJSON.data.error === "wrong_phone_number"
          ) {
            $(this)
              .find(".form-error")
              .html(
                `${$t("מספר הטלפון שהקשת שגוי.")}<br/><br/>
              ${$t(
                '<a href="https://wa.me/97237110400" target="_blank">לחץ כאן</a> לשיחה עם נציג לצורך השלמת הכניסה.',
                { link: window.siteData["whatsapp_link"] }
              )}`
              )
              .slideDown(150);
          } else {
            $(this).find(".form-error").text(message).slideDown(150);
          }

          $(this)
            .find("button[type=submit]")
            .text($t("התחבר"))
            .prop("disabled", false);
        });
    });
  },

  _hotelExtraContents() {
    const vm = this;

    if ($("li.extra-package").length) {
      $("li.extra-package").on("click", function (e) {
        e.preventDefault();
        if ($(".modal.extra-contents-modal").length) {
          $(".extra-contents-modal").modal().show();
        }
      });
    }

    $(document).on(
      "click",
      ".hotels-mobile-items .hotel-contents, .hotel-grid .item-contents",
      function (e) {
        e.preventDefault();
        e.stopPropagation();

        const hotelModal = $(this).data("hotel");
        if ($(".modal.hotel-contents-modal-" + hotelModal).length) {
          $(".hotel-contents-modal-" + hotelModal)
            .modal()
            .show();
        }
      }
    );

    $(".hotels-mobile-items .available-dates, .hotel-grid .available-dates").on(
      "click",
      function (e) {
        e.preventDefault();

        const hotelId = $(this).data("hotel");
        const $hotelModal = $(".hotel-packages-modal-" + hotelId);

        if ($hotelModal.length) {
          $hotelModal.find(".hotel-packages-list").show();

          $hotelModal.modal().show();
        } else {
          const $modalElem = createModal("hotel-packages-modal");
          const $modal = $modalElem.appendTo("body").modal();
          $modal.show();
          $modal.showLoader();

          const group = window.siteData.customer.group;

          let url = "/modals/hotel-packages/" + hotelId;

          if (group) {
            url += `?group=${group}`;
          }

          api.request("GET", url).then((resp) => {
            $modalElem.find(".modal-content").html(resp.html);

            setTimeout(() => {
              $modalElem.find(".hotel-packages-list").show();
              vm._orderPackageBtn();
            }, 0);
          });
        }
      }
    );
  },

  _siteTabs() {
    const tabs = $(".site-tabs");

    tabs.each((idx, el) => {
      if ($(el).hasClass("site-tabs-swiper")) {
        return;
      }

      if (!$(el).find(".tab-links .tab-link.active").length) {
        const tabLink = $(el).find(".tab-links .tab-link:first-child");

        tabLink.addClass("active");
        const tabItem = $(el).find(".tabs-content .tab-item:first-child");

        if (tabItem.hasClass("tab-item-flex")) {
          tabItem.addClass("active-flex");
        } else {
          tabItem.addClass("active");
        }

        $(window).on("load", () => {
          if (!window.location.hash) {
            tabLink.trigger("site_tabs_clicked", [
              tabItem,
              tabLink.data("target"),
            ]);
          }
        });
      }
    });

    $(".site-tabs .tab-links .tab-link").on("click", function (e) {
      if (!$(this).hasClass("external-link")) {
        e.preventDefault();
        const target = $(this).data("target");
        const tabContents = $(this).parents(".site-tabs").find(".tabs-content");
        const targetEl = tabContents.find(".tab-item#tab-item-" + target);

        $(this).parents(".tab-links").find(".tab-link").removeClass("active");

        tabContents.find(".tab-item").removeClass("active");
        tabContents.find(".tab-item").removeClass("active-flex");
        if (targetEl.hasClass("tab-item-flex")) {
          targetEl.addClass("active-flex");
        } else {
          targetEl.addClass("active");
        }

        $(this).trigger("site_tabs_clicked", [targetEl, target]);
        $(this).addClass("active");
      }
    });
  },

  _mobileHeaderAnimation() {
    const threshold = 200;
    let opacity = 0;
    $(window).on("scroll", function () {
      const top = $(this).scrollTop();

      if (top <= threshold) {
        opacity = top / threshold;
        $(".site-header-mobile .site-header-background").css(
          "opacity",
          opacity
        );
      } else if (opacity < 1) {
        opacity = 1;
        $(".site-header-mobile .site-header-background").css(
          "opacity",
          opacity
        );
      }
    });
  },

  _mobileMenus() {
    $(document).on("click", "li.menu-item", function (e) {
      e.preventDefault();
      e.stopPropagation();

      if ($(window).width() > 1024) return;

      if ($(this).hasClass("menu-item-has-children")) {
        $(this).toggleClass("active");

        if ($(this).hasClass("sites_dropdown")) {
          $(this)
            .find("> ul.sub-menu > li.sites_dropdown > ul.sub-menu")
            .stop()
            .slideToggle(250);
        }

        $(this).find("> .sub-menu").stop().slideToggle(250);
      }
    });

    $(document).on("click", "li.menu-item > a", function (e) {
      e.stopPropagation();
    });
  },

  _mobileDrawer() {
    $(document).on("click", ".site-menu-icon", function () {
      $(".site-drawer").show(0, () => {
        $(".site-drawer").addClass("active");
      });

      $("body").css("overflow", "hidden");
    });

    $(document).on(
      "click",
      ".site-drawer-overlay, .site-drawer .icon-close",
      function () {
        $("body").css("overflow", "auto");

        $(".site-drawer").removeClass("active");

        // Set display to none after animation is over.
        setTimeout(() => $(".site-drawer").hide(), 500);
      }
    );
  },

  _genericSliders() {
    $(".generic-slider").each(function () {
      new GenericSlider($(this));
    });
  },

  _fbGoogleEvents() {
    $(".home-whatsapp-contact").on("click", function () {
      window.fbq("track", "whatsapp");
      window.ga("send", "event", "whatsapp", "ctc", "m_s", 1);
    });

    $(".contact-information-chat").on("click", function () {
      window.fbq("track", "whatsapp");
      window.ga("send", "event", "whatsapp", "ctc", "m_s", 1);
    });

    $(".sticky-bottom-mobile .whatsapp a").on("click", function () {
      // window.fbq("track", "whatsapp");
      ga("send", "event", "whatsapp", "ctc", "m_s", 1);
    });

    $(".sticky-bottom-mobile .phone a").on("click", function () {
      ga("send", "event", "mobile", "ctc", "m_s", 1);
    });

    $("li.phone a").on("click", function () {
      window.fbq("track", "ctc");
      window.ga("send", "event", "ctc", "ctc", "ctc", 1);
    });
  },

  _siteMenuSearch() {
    const state = {
      expanded: false,
      sites: {
        loaded: false,
        loading: false,
        data: [],
      },
    };

    Vue.prototype.$icons = {
      "search-site-icon": require("../../images/icons/search-site-icon.svg"),
      "search-site-calendar": require("../../images/icons/search-site-calendar.png"),
      "search-site-ski": require("../../images/icons/search-site-ski.svg"),
    };

    new Vue({
      data: state,
      el: "#site-select-container .site-select-placeholder",
      template: `<SiteSelect @expand="expanded = true" :sites="sites" @load="onLoad" />`,
      methods: {
        onLoad(sites) {
          this.sites = sites;
        },
      },
      components: { SiteSelect },
    });

    new Vue({
      data: state,
      el: ".site-drawer-search .site-select-placeholder",
      template: `<SiteSelect @expand="expanded = true" :from-menu="true" :sites="sites" @load="onLoad" />`,
      methods: {
        onLoad(sites) {
          this.sites = sites;
        },
      },
      components: { SiteSelect },
    });

    new Vue({
      data: state,
      el: "#site-select-modal .site-select-placeholder",
      template: `<SiteSelect :modal="true" :expanded="expanded" :sites="sites" @collapse="expanded = false" />`,
      components: { SiteSelect },
    });
  },
  _stickyContactForm() {
    let $form = $("#sticky-contact-form");
    let $formToggle = $(".sticky-contact-toggle");

    $(window).on("scroll", function () {
      const top = $(this).scrollTop();

      if (top > 215 && !$formToggle.hasClass("hidden")) {
        $formToggle.addClass("hidden");
        $form.addClass("hidden");
      } else if (top < 215 && $formToggle.hasClass("hidden")) {
        $formToggle.removeClass("hidden");
        $form.removeClass("hidden");
      }
    });

    $form.find(".sticky-contact-form-close").click(function () {
      $form.addClass("closed");
      setTimeout(() => {
        $formToggle.addClass("active");
      }, 300);
    });

    $formToggle.on("click", function () {
      $formToggle.removeClass("active");
      $form.removeClass("closed");
    });
  },

  _continueOrderModal() {
    $(".continue-order-modal .continue-order-send-email").click(() => {
      $(".continue-order-modal .screen-1").addClass("inactive");
      $(".continue-order-modal .screen-2").removeClass("inactive");
    });

    $(".continue-order-modal .continue-order-quit").click(() => {
      $(".continue-order-modal").modal().hide();

      window.location.href = "/";
    });
  },

  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
